<template>
  <div>
    <!-- 取消申请 -->
    <el-dialog :title="$t('message.cancellationRequest')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="542px" center>
      <div class="content">
        <div class="prompt">是否取消该条出入金变更申请，取消后将无法继续操作。</div>
        <!-- 登记时间 -->
        <div class="row">
          <div class="label">{{ $t('message.registrationTime') }}</div>
          <div class="value">{{ datas.created_at }}</div>
        </div>
        <!-- 申请人:  -->
        <div class="row">
          <div class="label">{{ $t('message.theApplicant') }}</div>
          <div class="value">{{ datas.created_by_admin.realname }}</div>
        </div>
        <!-- 申请原因: -->
        <div class="row">
          <div class="label">{{ $t('message.reasonForApplication') }}</div>
          <div class="value">{{ datas.adjust_reason }}</div>
        </div>
        <!-- 出入金类型 -->
        <div class="row">
          <div class="label">{{ $t('message.depositWithdrawalType') }}</div>
          <div class="value">{{ datas.type_name }}</div>
        </div>
        <!-- 出入金金额  -->
        <div class="row">
          <div class="label">{{ $t('message.depositWithdrawalAmount') }}</div>
          <div class="value">{{ datas.amount }}円</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 取消 -->
        <el-button @click="dialogVisible = false">{{ $t('message.cancel') }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="adjustApplicationCancel">{{ $t('message.cancellationRequest') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      datas: {
        created_by_admin: {}
      },

    };
  },
  methods: {
    //取消申请
    adjustApplicationCancel() {
      this.$api.financialApi.adjustApplicationCancel({ id: this.datas.id }).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.$parent.adjustApplicationListTab()
        this.$parent.adjustApplicationList()
      })
    },
  }
}
</script>
<style lang='scss' scoped>
.content {
  margin: 0 20px;
  font-size: 16px;

  .prompt {
    color: red;
    margin-bottom: 15px;
  }

  .row {
    display: flex;
    margin-bottom: 15px;

    .label {
      width: 120px;
      margin-right: 12px;
    }
  }
}
</style>